import React from 'react';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { ServerSaveStatus } from 'components';

const ServerSaveStatusContainer = props => <ServerSaveStatus {...props} />;

const mapStateToProps = state => ({
  serverSaveStatus: fromReservation.getServerSaveStatus(state),
});

export default connect(mapStateToProps)(ServerSaveStatusContainer);



// WEBPACK FOOTER //
// ./src/containers/ServerSaveStatus.js